import { versionNegotiation } from 'lisecutilityfunctions/lib/openapi';
import OpenApiClient_customer_management_v2 from './openapiclient_customer_management_v2';
import OpenApiClient_customer_management_v2_1 from './openapiclient_customer_management_v2_1';
import OpenApiClient_customer_management_v2_2 from './openapiclient_customer_management_v2_2';

import { CM_CLIENT_v2 } from '../utils/appConstants';

export const apiVersionCM = {
    '2.0': OpenApiClient_customer_management_v2,
    '2.1': OpenApiClient_customer_management_v2_1,
    '2.2': OpenApiClient_customer_management_v2_2
};

export const customerManagementServiceName = 'customer_management';

let isCallbackMethod = false;

export const getNegotiatedClientFile = async () =>
    await versionNegotiation(customerManagementServiceName, apiVersionCM, isCallbackMethod);

export const getVersions = async () => {
    const versionClientFile = await getNegotiatedClientFile();
    let versionKey = CM_CLIENT_v2; //("2.0")
    for (const key in apiVersionCM) {
        if (apiVersionCM[key as keyof typeof apiVersionCM] === versionClientFile) {
            versionKey = key;
        }
    }
    return versionKey;
};
